var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.21 99.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.61,98.91C22.43,98.91.31,76.79.31,49.61S22.43.31,49.61.31s49.3,22.12,49.3,49.3-22.12,49.3-49.3,49.3ZM49.61,2.31C23.53,2.31,2.31,23.53,2.31,49.61s21.22,47.3,47.3,47.3,47.3-21.22,47.3-47.3S75.69,2.31,49.61,2.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.44,67.43c-.11,0-.22-.01-.33-.04-.4-.09-.74-.34-.95-.69l-9.13-15.22c-.43-.71-.2-1.63.51-2.06.71-.43,1.63-.2,2.06.51l8.32,13.88,42.05-27.8c.69-.46,1.62-.27,2.08.42.46.69.27,1.62-.42,2.08l-43.36,28.66c-.25.16-.54.25-.83.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.d6eda883a78a12705be5dafe52656b2d.svg";
export { ForwardRef as ReactComponent };